export const CLIENTES_GET_LISTA_DE_CLIENTES_BEGIN = 'CLIENTES_GET_LISTA_DE_CLIENTES_BEGIN';
export const CLIENTES_GET_LISTA_DE_CLIENTES_SUCCESS = 'CLIENTES_GET_LISTA_DE_CLIENTES_SUCCESS';
export const CLIENTES_GET_LISTA_DE_CLIENTES_FAILURE = 'CLIENTES_GET_LISTA_DE_CLIENTES_FAILURE';
export const CLIENTES_GET_LISTA_DE_CLIENTES_DISMISS_ERROR = 'CLIENTES_GET_LISTA_DE_CLIENTES_DISMISS_ERROR';
export const CLIENTES_GET_CLIENTE_BEGIN = 'CLIENTES_GET_CLIENTE_BEGIN';
export const CLIENTES_GET_CLIENTE_SUCCESS = 'CLIENTES_GET_CLIENTE_SUCCESS';
export const CLIENTES_GET_CLIENTE_FAILURE = 'CLIENTES_GET_CLIENTE_FAILURE';
export const CLIENTES_GET_CLIENTE_DISMISS_ERROR = 'CLIENTES_GET_CLIENTE_DISMISS_ERROR';
export const CLIENTES_CLEAR_CLIENTE = 'CLIENTES_CLEAR_CLIENTE';
export const CLIENTES_CLEAR_LISTA_DE_CLIENTES = 'CLIENTES_CLEAR_LISTA_DE_CLIENTES';
export const CLIENTES_HANDLE_ON_CHANGE_CLIENTE = 'CLIENTES_HANDLE_ON_CHANGE_CLIENTE';

export const CLIENTES_SET_CLIENTE_BEGIN = 'CLIENTES_SET_CLIENTE_BEGIN';
export const CLIENTES_SET_CLIENTE_SUCCESS = 'CLIENTES_SET_CLIENTE_SUCCESS';
export const CLIENTES_SET_CLIENTE_FAILURE = 'CLIENTES_SET_CLIENTE_FAILURE';
export const CLIENTES_SET_CLIENTE_DISMISS_ERROR = 'CLIENTES_SET_CLIENTE_DISMISS_ERROR';

export const CLIENTES_ADD_CLIENTE_BEGIN = 'CLIENTES_ADD_CLIENTE_BEGIN';
export const CLIENTES_ADD_CLIENTE_SUCCESS = 'CLIENTES_ADD_CLIENTE_SUCCESS';
export const CLIENTES_ADD_CLIENTE_FAILURE = 'CLIENTES_ADD_CLIENTE_FAILURE';
export const CLIENTES_ADD_CLIENTE_DISMISS_ERROR = 'CLIENTES_ADD_CLIENTE_DISMISS_ERROR';

export const CLIENTES_SAME_CLIENT = 'Existe un cliente con los mismos datos';